import { render, staticRenderFns } from "./LanguageButton.vue?vue&type=template&id=5dd212ee&scoped=true&"
import script from "./LanguageButton.vue?vue&type=script&lang=js&"
export * from "./LanguageButton.vue?vue&type=script&lang=js&"
import style0 from "./LanguageButton.vue?vue&type=style&index=0&id=5dd212ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd212ee",
  null
  
)

export default component.exports